import { Component } from '@angular/core';
import { ViewController, ModalController, NavParams,NavController } from 'ionic-angular';
import { SignUpPage } from '../sign-up/sign-up';
import { Http } from '@angular/http';
import { ConfigProvider } from '../../providers/config/config';
import { LoadingProvider } from '../../providers/loading/loading';
import { ForgotPasswordPage } from '../forgot-password/forgot-password';
import { SharedDataProvider } from '../../providers/shared-data/shared-data';
import { Facebook, FacebookLoginResponse } from '@ionic-native/facebook';
import { AlertProvider } from '../../providers/alert/alert';
import { GooglePlus } from '@ionic-native/google-plus';
import { ProductsPage } from '../products/products';
import { HomePage } from '../home/home';



@Component({
  selector: 'page-pricing',
  templateUrl: 'pricing.html',

})
export class NewPricePage {
  formData = { newPrice: '', product_id: '',customer_id:'' };
  errorMessage = '';
	product ={products_id:''};
	product_image = '';

  constructor(
    public http: Http,
		public navParams: NavParams,
    public config: ConfigProvider,
    public viewCtrl: ViewController,
    public modalCtrl: ModalController,
    public loading: LoadingProvider,
    public shared: SharedDataProvider,
    private fb: Facebook,
    public alert: AlertProvider,
    private googlePlus: GooglePlus,
		public navCtrl: NavController,
		params: NavParams
  ) {
		this.product = params.get('product');
console.log("Pricing Change for:",this.product.products_id);
  }

	updatePricing(){

	//	this.loading.show();
		this.errorMessage = '';
		this.formData.customer_id = this.shared.customerData.customers_id;
		this.formData.product_id = this.product.products_id;
		this.http.post(this.config.url + 'updatePricing', this.formData).map(res => res.json()).subscribe(data => {
		//	this.loading.hide();
			if (data.success == 1) {
        this.viewCtrl.dismiss();

      }
      if (data.success == 0) {
        this.errorMessage = data.message;
      }
    });


	}
  //close modal
  dismiss() {
		console.log("Dismiss");
    this.viewCtrl.dismiss();
  }

}



// WEBPACK FOOTER //
// ./src/pages/pricing/pricing.ts